import { QuoteRequestDTO } from '@luminovo/http-client';
import { formatSupplierDTO } from '@luminovo/sourcing-core';

export function formatQuoteRequest(quoteRequest: QuoteRequestDTO) {
    return `${formatSupplierDTO(quoteRequest.supplier)} # ${quoteRequest.number}`;
}
